import React, { useState } from 'react';
import { Button } from 'antd';
import styled from 'styled-components';

import { StyledButton } from '../../components/Button';
import { CandidateType } from '../candidates/Candidates.types';
import { RecruitmentHistoryType } from '../recruitments/Recruitments.types';

import { ReminderForm } from './ReminderForm';
import { StatusAndNoteForm } from './StatusAndNoteForm';

const SwitchModeButtonsContainer = styled.div`
  display: flex;
  height: 45px;
  margin-bottom: 10px;
`;

const SwitchModeButton = styled(Button)`
  flex-grow: 1;
  height: 100%;
  text-align: center;
`;

export const SubmitButton = styled(StyledButton).attrs({
  type: 'primary',
})``;

export const ClearButton = styled(StyledButton).attrs({
  type: 'ghost',
})``;

export type RecruitmentDataFormProps = {
  candidate: CandidateType;
  recruitment: RecruitmentHistoryType;
};

enum RecruitmentFormModeEnum {
  STATUS_AND_NOTE,
  REMINDER,
}

export const RecruitmentDataForm: React.FC<RecruitmentDataFormProps> = ({ candidate, recruitment }) => {
  const [mode, setMode] = useState<RecruitmentFormModeEnum>(RecruitmentFormModeEnum.STATUS_AND_NOTE);
  const isStatusAndNoteMode = mode === RecruitmentFormModeEnum.STATUS_AND_NOTE;
  const isReminderMode = mode === RecruitmentFormModeEnum.REMINDER;

  return (
    <div>
      <SwitchModeButtonsContainer>
        <SwitchModeButton
          type={isStatusAndNoteMode ? 'primary' : 'default'}
          onClick={() => setMode(RecruitmentFormModeEnum.STATUS_AND_NOTE)}
        >
          Status & Note
        </SwitchModeButton>

        <SwitchModeButton
          type={isReminderMode ? 'primary' : 'default'}
          onClick={() => setMode(RecruitmentFormModeEnum.REMINDER)}
        >
          Reminder
        </SwitchModeButton>
      </SwitchModeButtonsContainer>

      {isStatusAndNoteMode && <StatusAndNoteForm candidate={candidate} recruitment={recruitment} />}
      {isReminderMode && <ReminderForm recruitment={recruitment} />}
    </div>
  );
};
